export const Logo = ({ width, height, viewBox, ...rest }) => (
  <svg
    width={width || '138'}
    height={height || '60'}
    viewBox={viewBox || '0 0 138 60'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M23.2798 27.0798H27.0902C27.0759 24.0228 24.8555 22 21.3029 22C17.8148 22 15.351 23.9924 15.3724 26.9582C15.3653 29.3916 16.9553 30.7452 19.5553 31.3384L21.0164 31.673C22.6495 32.0532 23.2082 32.4867 23.2225 33.1939C23.2082 33.962 22.5492 34.5019 21.2743 34.5019C19.7487 34.5019 18.8462 33.7414 18.7818 32.3118H15C15.0143 36.2205 17.5069 37.9696 21.3316 37.9696C25.0489 37.9696 27.2764 36.2662 27.2907 33.1939C27.2764 30.8213 25.9442 29.1559 22.7068 28.4183L21.5035 28.1445C20.114 27.8327 19.4908 27.3992 19.5267 26.654C19.5338 25.9696 20.071 25.4677 21.3029 25.4677C22.5922 25.4677 23.201 26.0684 23.2798 27.0798Z"
      fill="#4F64D7"
    />
    <path
      d="M72.5554 27.6666L68.5731 30.3333V37.787H72.5554V27.6666Z"
      fill="#4F64D7"
    />
    <path
      d="M105.126 30C105.126 24.7985 101.975 22 97.9923 22C93.9813 22 90.8585 24.7985 90.8585 30C90.8585 35.1711 93.9813 38 97.9923 38C101.975 38 105.126 35.2015 105.126 30ZM101.029 30C101.029 32.7985 99.9691 34.3194 97.9923 34.3194C96.0155 34.3194 94.9554 32.7985 94.9554 30C94.9554 27.2015 96.0155 25.6806 97.9923 25.6806C99.9691 25.6806 101.029 27.2015 101.029 30Z"
      fill="#4F64D7"
    />
    <path d="M85.6395 22L81.6572 25V38H85.6395L85.6395 22Z" fill="#4F64D7" />
    <path
      d="M50.7435 37.787L51.5887 34.806H56.4305L57.2756 37.787H61.5731L56.7313 22.2129H51.2879L46.446 37.787H50.7435ZM52.4911 31.6425L53.9523 26.5019H54.0669L55.528 31.6425H52.4911Z"
      fill="#4F64D7"
    />
    <path
      d="M32.1672 37.787H36.1495V33.1635H38.3556C41.7004 33.1635 43.9423 31.0722 43.9423 27.7186C43.9423 24.403 41.7577 22.2129 38.4988 22.2129H32.1672V37.787ZM36.1495 29.8783V25.5893H37.5534C38.9501 25.5893 39.7881 26.3802 39.7881 27.7186C39.7881 29.0494 38.9501 29.8783 37.5534 29.8783H36.1495Z"
      fill="#4F64D7"
    />
    <path
      d="M68.4873 25.6199H64.0752V22.213H76.8243V25.6199H72.4123H68.4873Z"
      fill="#4F64D7"
    />
    <path
      d="M122.506 22.3334H118.523V30.4855H118.409L113.195 22.3334H109.814V37.9075H113.796V29.725H113.882L119.182 37.9075H122.506V22.3334Z"
      fill="#4F64D7"
    />
  </svg>
);
